import Loadable from '../../components/loadable';

const GymSmsSettings = Loadable({
  loader: () => import('../../pages/account_profile/gym_sms_settings'),
});

angular.module('gym').value('GymSmsSettings', GymSmsSettings);
